import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.css']
})
export class OrganizationDetailsComponent implements OnInit {
  orgId!: any;
  organization: any;

  constructor(private route: ActivatedRoute,
    private readonly apiService: ApiService,
    private toastrMsgService: ToastrService) { }
  ngOnInit(): void {
    this.orgId = this.route.snapshot.paramMap.get('id');
    console.log(this.orgId)
    this.getOrganizationDetails(this.orgId)
  }

  getOrganizationDetails(orgId: any) {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {
        const data = res.data.find((project: any) => project.org_id == orgId);
        this.organization = data;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }
}
